export default from './app';



// WEBPACK FOOTER //
// ./app/containers/app/index.js